/** 報價單狀態：DRAFT → ISSUED（#83 發出）；EXPIRED 是後端衍生（已發出且 valid_until 早於台北當日）。 */

export const QUOTATION_STATUS = {
  DRAFT: 'DRAFT',
  ISSUED: 'ISSUED',
  EXPIRED: 'EXPIRED',
};

export const QUOTATION_STATUS_LABELS = {
  DRAFT: '草稿',
  ISSUED: '已發出',
  EXPIRED: '已過期',
};

export const QUOTATION_STATUS_FILTER_OPTIONS = [
  { value: 'DRAFT', label: '草稿' },
  { value: 'ISSUED', label: '已發出' },
  { value: 'EXPIRED', label: '已過期' },
];

export function formatQuotationStatusLabel(status) {
  if (status == null || status === '') {
    return '-';
  }
  return QUOTATION_STATUS_LABELS[status] ?? status;
}

/** 更新與刪除只對 DRAFT（非草稿回 409）。 */
export function canEditQuotationDraft(status) {
  return status === QUOTATION_STATUS.DRAFT;
}

export function canDeleteDraftQuotation(status) {
  return status === QUOTATION_STATUS.DRAFT;
}

export function canIssueQuotation(status) {
  return status === QUOTATION_STATUS.DRAFT;
}

/** 已發出／過期：客戶可見內容凍結，只能改表頭與各列內部備註。 */
export function canUpdateQuotationInternalRemarkOnly(status) {
  return status === QUOTATION_STATUS.ISSUED || status === QUOTATION_STATUS.EXPIRED;
}
